var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55564 4.63366C3.25044 3.43453 4.35735 2.52876 5.67027 2.08502C6.98319 1.64127 8.41264 1.68979 9.69245 2.22154C10.9723 2.75329 12.0152 3.73203 12.6271 4.97552C13.239 6.21901 13.3781 7.64249 13.0186 8.98092C12.659 10.3194 11.8253 11.4815 10.6727 12.251C9.52007 13.0205 8.12707 13.3449 6.75308 13.1637C5.37909 12.9826 4.11774 12.3083 3.20391 11.2664C2.29008 10.2245 1.78604 8.88597 1.78564 7.50009",
    stroke: "#1D3557",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35714 4.64303H2.5V1.78589",
    stroke: "#1D3557",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.508e817017464a67407f0c83a9c953bd.svg";
export { ForwardRef as ReactComponent };